import React, { useEffect, useMemo, useState } from "react";
import TableContainer from "../../components/Common/TableContainer";
import Breadcrumb from "../../components/Common/Breadcrumb";
import { Card, CardBody, Button, Container } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { apiUrl, formatDate, getRecords } from "../../services/api.service";
import { exportPageData } from "./InstallationListFile";
import moment from "moment";

const breadcrumbItems = [];

const InstallationList = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [exportData, setExportData] = useState([]);
  const [counts, setCounts] = useState({
    created: 0,
    approved: 0,
    claimed: 0,
    paid: 0,
  });

  useEffect(() => {
    const projectId = JSON.parse(localStorage.getItem("projectID"));
    const contractor_id = JSON.parse(localStorage.getItem("userDetails"))?.id;

    getData(projectId, contractor_id);
    fetchCounts(projectId);
  }, [searchKeyword, page, pageSize]);

  useEffect(() => {
    const projectId = JSON.parse(localStorage?.getItem("projectID"));
    const contractor_id = JSON.parse(localStorage.getItem("userDetails"))?.id;

    handleExportData(projectId, contractor_id);
  }, []);

  const fetchCounts = async (projectId) => {
    try {
      const response = await fetch(`${apiUrl}/buyItemCount/${projectId}`);
      if (!response.ok) {
        throw new Error("Failed to fetch counts");
      }
      const data = await response.json();
      setCounts({
        created: data.totalCreated || 0,
        approved: data.totalApproved || 0,
        claimed: data.totalClaimed || 0,
        paid: data.totalPaid || 0,
      });
    } catch (error) {
      console.error("Error fetching counts:", error);
    }
  };
  const getData = async (Id, contractor_id) => {
    try {
      const payload = {
        modelName: "installations",
        whereCondition: {
          project_id: Id,
          // assigned_to: contractor_id,
          is_active: true,
        },
        relations: [
          {
            module: "user_masters",
            moduleAs: "createdByUser",
          },
          {
            module: "projects",
            moduleAs: "projects",
          },
          {
            module: "installation_commissioning_list_masters",
            moduleAs: "installationCommissioning",
          },
        ],
        pagination: {
          page: page + 1,
          pageSize: pageSize,
        },
        search: {
          searchKeyword: searchKeyword,
          field_name: [
            "field_name",
            "installationCommissioning.form_name",
            "createdByUser.first_name",
            "installation_no",
            "projects.project_name",
          ],
        },
      };
      const responseData = await getRecords(payload, "/getRecords");
      responseData.data.forEach((element, index) => {
        element.index = index + 1;
      });

      setTotalCount(responseData.count);

      const sortedData = responseData.data.sort((a, b) => b.index - a.index);
      setData(sortedData);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleClickAdd = () => {
    navigate("/outward-create");
  };

  const handleViewClick = (id) => {
    navigate(`/installationlist-view/${id}`);
  };

  const getSearchInputData = (inputValue) => {
    setSearchKeyword(inputValue);
  };

  const nextToPages = () => {
    setPage(page + 1);
  };

  const previousToPages = () => {
    setPage(page - 1);
  };

  const handlePageSizeChange = (data) => {
    setPageSize(data);
    const newTotalPages = Math.ceil(totalCount / data);
    if (page >= newTotalPages) {
      setPage(0);
    }
  };

  const lastToPages = () => {
    setPage(Math.ceil(totalCount / pageSize) - 1);
  };

  const previousFirstToPages = () => {
    setPage(0);
  };
  const getInstallationStatusText = (item) => {
    const status = item?.status;
    const isPaid = item?.is_installation_paid;
    const isClaimed = item?.is_installation_claimed;

    if (isPaid) {
      return "Installation Paid";
    } else if (isClaimed) {
      return "Installation Claimed";
    } else if (status === "installation_approved") {
      return "Installation Approved";
    } else if (status === "commissioning_completed") {
      return "Installation Completed";
    } else if (status === "installation_created") {
      return "Installation Created";
    } else if (status === "installation_rejected") {
      return "Installation Rejected";
    } else if (status === "installation_completed") {
      return "Installation Completed";
    } else {
      return "N/A";
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: "SR.NO",
        accessor: "index",
        accessor: (row) => page * pageSize + row.index,
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "50px" }}>{value}</div>,
      },
      {
        Header: "PROJECT NAME",
        accessor: (row) =>
          row?.projects?.project_name ? row?.projects?.project_name : "-",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "150px" }}>{value}</div>,
      },
      {
        Header: "INSTALLATION NO",
        accessor: (row) => (row?.installation_no ? row?.installation_no : "-"),
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "150px" }}>{value}</div>,
      },
      {
        Header: "INSTALLATION PERSON",
        accessor: (row) =>
          row?.createdByUser
            ? row?.createdByUser.first_name + " " + row?.createdByUser.last_name
            : "-",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "150px" }}>{value}</div>,
      },
      {
        Header: "INSTALLATION DATE",
        accessor: (row) => (row?.createdAt ? formatDate(row?.createdAt) : "-"),
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "150px" }}>{value}</div>,
      },
      {
        Header: "FORM NAME",
        accessor: (row) =>
          row?.installationCommissioning?.form_name &&
          row?.installationCommissioning?.form_name
            ? row?.installationCommissioning?.form_name
            : "-",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "150px" }}>{value}</div>,
      },

      {
        Header: "FIELD NAME",
        accessor: (row) =>
          row?.field_name && row?.field_name ? row?.field_name : "-",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "150px" }}>{value}</div>,
      },
      {
        Header: "INSTALLATION STATUS",
        accessor: (row) => row?.status || "-",
        disableFilters: true,
        filterable: false,
        Cell: ({ row, value }) => {
          let text = "-";
          let badgeClass = "text-secondary";
          let inlineStyle = {};
          if (row.original?.is_installation_paid) {
            text = "Installation Paid";
            inlineStyle = {
              backgroundColor: "#90EE90",
              color: "black",
            };
          } else if (row.original?.is_installation_claimed) {
            text = "Installation Claimed";
            badgeClass = "bg-primary-subtle text-primary";
          } else if (
            value === "installation_approved" ||
            value === "commissioning_completed"
          ) {
            text = "Installation Approved";
            badgeClass = "bg-success-subtle text-success";
          } else if (value === "installation_created") {
            text = "Installation Created";
            badgeClass = "bg-warning-subtle text-warning";
          } else if (value === "installation_rejected") {
            text = "Installation Rejected";
            badgeClass = "bg-danger-subtle text-danger";
          } else if (value === "installation_completed") {
            text = "Installation Completed";
            badgeClass = "bg-info-subtle text-info";
          }

          return (
            <div style={{ width: "150px" }}>
              <span
                style={inlineStyle}
                className={`badge ${badgeClass} text-uppercase`}
              >
                {text}
              </span>
            </div>
          );
        },
      },
      {
        Header: "STATUS",
        accessor: "is_active",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => (
          <div style={{ width: "100px" }}>
            {value === 0 ? (
              <span className="badge bg-danger-subtle text-danger text-uppercase">
                In-active
              </span>
            ) : (
              <span className="badge bg-success-subtle text-success text-uppercase">
                Active
              </span>
            )}
          </div>
        ),
      },
      {
        Header: "ACTION",
        accessor: "actions",
        disableFilters: true,
        filterable: false,
        Cell: ({ row }) => (
          <div style={{ width: "150px" }}>
            <div
              onClick={() => {
                handleViewClick(row.original.id);
              }}
            >
              <Link className="me-3 text-primary">
                <i className="mdi mdi-eye font-size-18"></i>
              </Link>
            </div>
          </div>
        ),
      },
    ],
    [page, pageSize]
  );

  const handleExportData = async (projectId, contractor_id) => {
    try {
      const payload = {
        modelName: "installations",
        whereCondition: {
          project_id: projectId,
          // assigned_to: contractor_id,
          is_active: true,
        },
        relations: [
          {
            module: "user_masters",
            moduleAs: "createdByUser",
          },
          {
            module: "projects",
            moduleAs: "projects",
          },
          {
            module: "installation_commissioning_list_masters",
            moduleAs: "installationCommissioning",
          },
        ],
        pagination: { page: 1, pageSize: 100000 },
      };

      const responseData = await getRecords(payload, "/getRecords");
      if (responseData?.data.length == 0) setExportData([]);
      const exportData = responseData?.data.map((item, index) => ({
        "SR. NO": index + 1,
        "PROJECT NAME": item?.projects?.project_name || "N/A",
        "INSTALLATION NO": item?.installation_no || "N/A",
        "INSTALLATION PERSON":
          item?.createdByUser?.first_name +
            " " +
            item?.createdByUser?.last_name || "N/A",
        "INSTALLATION DATE": item?.createdAt || "N/A",
        "FORM NAME": item?.installationCommissioning?.form_name || "N/A",
        "FIELD NAME": item?.field_name || "N/A",
        "INSTALLATION STATUS": getInstallationStatusText(item),
        STATUS:
          item?.is_active === false || item?.is_active === 0
            ? "In-active"
            : "Active",
      }));
      setExportData(exportData);
    } catch (error) {
      console.error("Error fetching records:", error);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "10px",
            }}
          >
            <Breadcrumb
              title="Installation List"
              breadcrumbItems={breadcrumbItems}
            />
          </div>

          <Card>
            <CardBody>
              <TableContainer
                columns={columns || []}
                data={data || []}
                isPagination={false}
                // isGlobalFilter={false}
                iscustomPageSize={false}
                isBordered={false}
                customPageSize={10}
                isLoading={isLoading}
                onSearchInputData={getSearchInputData}
                pageIndexProp={page}
                onPageSizeChange={handlePageSizeChange}
                nextToPage={nextToPages}
                lastToPage={lastToPages}
                previousToPage={previousToPages}
                previousFirstToPage={previousFirstToPages}
                totalCount={totalCount}
                exportData={exportData}
                exportFileName={exportPageData?.fileName}
                counts={counts}
              />
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default InstallationList;
